// HTML escape 單一來源 — 防 stored XSS（菜單名 / 分類名等使用者輸入進 innerHTML 前必過）
// see architecture.md#L700
//
// 歷史：各元件原本各自複製一份 escapeHtml，最早期的 pos-menu-grid /
// pos-menu-item / pos-cart 漏掉導致品項名 XSS。新元件一律 import 這裡。

export function escapeHtml(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}
